///** @jsxImportSource @emotion/react */
//import { css } from '@emotion/react'
//import React, { useState, useEffect, Fragment } from 'react';
//import { ActionButton, mergeStyleSets, } from '@fluentui/react';
//import htmr from 'htmr';
//const fadeIn = (item) => css`
//    position: absolute;
//    right: 0px;
//    left: 0px;
//    top: 100px;
//    max-height: calc(100% - 50px);
//    min-height: 100%;
//    overflow: auto;
//`;
//function Explanation(props) {
//    return (
//        <div className={styles.bg}>
//            <div className="fadein" css={fadeIn}>
//                <div className={styles.header}>
//                    <h4 className="head-s" style={{ color: 'var(--status-error-text)' }}>Incorrect</h4>
//                </div>

//                <div className="pt20 pb20">
//                    <h5 className="head-xs mb10" style={{ letterSpacing: 0, color: 'var(--palette-black-alpha-100)', fontSize: 12 }}>WHY IT WAS WRONG</h5>
//                    {htmr(props.data.explanation)}
//                </div>
//                <div className=" displayflex justifyflexend pabsolute" style={{ bottom: 30, right:0 }}>
//                    <ActionButton onClick={() => { props.callback(props.complete); props.setShowExplanation(false) }} style={{ color: 'var(--focus-border-color)' }}>
//                        Next <i class="ms-Icon ms-Icon--Forward ml5"></i>
//                    </ActionButton>
//                </div>
//            </div>
//        </div>
//    );
//}
//const styles = mergeStyleSets({
//    header: {
//        backgroundColor: 'rgba(var(--palette-neutral-100), 0.06)',
//        display: 'flex',
//        alignItems: 'center',
//        justifyContent: 'center',
//        padding: 10
//    }
//});
//export default Explanation;


import React, { useState, useEffect, Fragment } from 'react';
import { mergeStyleSets, PrimaryButton } from '@fluentui/react';
import { CheckmarkCircleFilled, DismissCircleFilled, InfoFilled } from '@fluentui/react-icons';

import htmr from 'htmr';
function Explanation(props) {
    // isCorrect: true = graded correct, false = graded incorrect, null/undefined = grade hidden (neutral)
    const isCorrect = props.isCorrect;
    const color = isCorrect === true ? 'var(--green)' : isCorrect === false ? 'var(--danger)' : '#33559A';
    const Icon = isCorrect === true ? CheckmarkCircleFilled : isCorrect === false ? DismissCircleFilled : InfoFilled;
    const title = isCorrect === true ? 'Correct' : isCorrect === false ? 'Incorrect' : 'Explanation';
    const heading = isCorrect === false ? 'WHY IT WAS WRONG' : 'EXPLANATION';

    return (
        <div className={styles.bgSuccess}>
            <div className="width100 height100 justifycenter flexcolumn aligncenter prelative">
                <div className="flexcolumn aligncenter" style={{marginTop:150} }>
                    <Icon style={{ fontSize: 85, color }} />
                    <h4 className="head-m mt10 mb30" style={{ color }}>{title}</h4>
                </div>
                <div className="pt10 pb20">
                    <h5 className="head-xs mb10" style={{ letterSpacing: 0, color: 'var(--palette-black-alpha-100)', fontSize: 12 }}>{heading}</h5>
                    {htmr(props.data.explanation)}
                </div>
                <div className=" displayflex justifycenter mt20" >
                    <PrimaryButton className="btn-primary" onClick={() => { props.callback(props.complete); props.setShowExplanation(false) }} text="Next" />
                </div>
            </div>
        </div>
    );
}
const styles = mergeStyleSets({
    bgSuccess: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        padding:20,
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});
export default Explanation;